import React from 'react';

const Home = () => {
  const text = 'Joining the Promethean Saga Soon';

  return (
    <div className="w-full h-[80vh] flex justify-center items-center ">
      <div className="flex flex-col justify-center items-center gap-4">
        <img alt="logo" src="/images/logobg.png" className="w-60 h-60 z-100" />
        <img alt="logo" src="/images/xion.png" className="h-10 z-100 -mt-14" />


        <div className="text-white text-xl font-normal tracking-wide flex cursor-default mt-4">
          {text.split('').map((letter, index) => (
            <span key={index} className="animate-slide-down inline-block">
              {letter === ' ' ? '\u00A0' : letter}
            </span>
          ))}
        </div>
      </div>
      
    </div>
  );
};

export default Home;
